import { useGetStrings } from "@app/store/service/cmsService"
import { useToasts } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useEffect, useRef } from "react"

export const ToastErrorHandler = () => {
	const { addToast } = useToasts()
	const used = useRef([])
	const errors = useSelector(state => state.errors)
	const {
		data: { errorMessages },
	} = useGetStrings(undefined, { defaultData: { errorMessages: [] } })

	useEffect(() => {
		for (let error of errors) {
			if (used.current.indexOf(error.id) === -1) {
				let m = errorMessages.find(e => e.internal === error.errorMessage)
				let message = m ? { ...m } : undefined

				let obj = {
					title: "",
					body: "",
					variant: "danger",
					autoDismiss: false,
					errorId: error.id,
				}

				if (message) {
					obj.title = message.title
					for (let key of Object.keys(error.replacements || {})) {
						message.body = message.body.replace(key, error.replacements[key])
					}
					obj.body = <div className="mt-2">{message.body}</div>
				} else {
					obj.title = error.errorMessage + (error.response ? ";" + error.response.status : "")
					obj.body = (
						<div className="mt-2" style={{ wordBreak: "break-all" }}>
							{error.body ? JSON.stringify(error.body) : ""}
						</div>
					)
				}
				addToast(obj)
				used.current.push(error.id)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [errors])

	return null
}
